import { helpers } from "@vuelidate/validators";
import { get } from "lodash";

export interface FileUploadValue {
  name?: string;
  content_type: string;
  comments?: string;
  document_id?: string;
}

export const requiredFile = () =>
  helpers.withParams({ type: "requiredFile" }, (value: FileUploadValue | null) =>
    Boolean(value?.content_type || value?.document_id)
  );

export const acceptedFileTypes = (allowedTypes: string[]) =>
  helpers.withParams({ type: "acceptedFileTypes", allowedTypes }, (value: FileUploadValue | null) => {
    if (!value?.content_type) {
      return true;
    }

    if (allowedTypes.includes("image/*") && value.content_type.startsWith("image/")) {
      return true;
    }

    return allowedTypes.includes(value.content_type);
  });

export const exceedsMaxFileSize = (file: File, maxSizeInBytes: number): boolean => file.size > maxSizeInBytes;

export const isOlderThanAllowed = (file: File, settings: any): boolean => {
  const lastModified: number | null = get(file, "lastModified", null);

  if (!lastModified) {
    return false;
  }

  const deltaDate = new Date();
  deltaDate.setDate(deltaDate.getDate() + get(settings, "delta.day"));

  return new Date(lastModified) <= deltaDate;
};

export const isBelowMinWidth = (file: File, minWidth: number): Promise<boolean> =>
  new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => resolve(img.width < minWidth);
      img.onerror = () => resolve(true);
      img.src = e.target?.result as string;
    };

    reader.onerror = () => resolve(true);
    reader.readAsDataURL(file);
  });
